/** A readable message out of an Axios error. FastAPI returns `detail` either as a string or as
 *  `{ error_code, message }`; neither shape matching falls back to *fallback*. */
export function extractApiError(err, fallback = 'Ein unbekannter Fehler ist aufgetreten.') {
    if (err?.code === 'ECONNABORTED') return 'Verbindung zum Server unterbrochen. Bitte versuche es erneut.';
    const detail = err?.response?.data?.detail;
    if (!detail) return fallback;
    if (typeof detail === 'string') return detail;
    if (typeof detail === 'object' && detail.message) return detail.message;
    return fallback;
}
